import { Box } from "@mui/material"
import { FC } from "react"
import { appConstants } from "src/features/shared-module/constants"

export const DropOrderPlaceholder: FC = () => {
  return (
    <Box
      data-testid="order-drop-placeholder"
      sx={{
        border: "1.5px dashed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
        height: appConstants.orderRawHeight,
        padding: 2,
      }}
    >
      Drop Order here
    </Box>
  )
}
